module.exports = __webpack_public_path__ + "img/offer-money-in.45725f18.svg";